/* src/pages/CyberSecurity.js */

import React from "react";
import PageSection from "../components/PageSection";
import { Helmet } from "react-helmet";
import styles from "./Pages.module.css"; // CSS Module
import cybersecurityImage from "../assets/Images/cybersecurity.jpg";

function CyberSecurity() {
  const faqs = [
    {
      question: "Do I really need cybersecurity?",
      answer:
        "If you handle customer data, take credit cards, or would be screwed if all your files disappeared tomorrow - yes. Small businesses get hit by ransomware and phishing attacks all the time because they're easy targets.",
    },
    {
      question: "What do you actually do?",
      answer:
        "I check your security setup, fix obvious problems, set up proper backups, and train your team to spot phishing emails. Basic stuff that prevents most attacks, without the enterprise price tag.",
    },
    {
      question: "How much does it cost?",
      answer:
        "Depends on what you need. Basic security checkup and fixes are way less than dealing with a ransomware attack. I'll give you honest advice on what's worth the money and what's overkill.",
    },
  ];

  return (
    <PageSection title="Cybersecurity for Shreveport-Bossier Businesses" cta faqs={faqs}>
      <Helmet>
        <title>Cybersecurity Services | Tharpe Industries</title>
        <meta
          name="description"
          content="Protect your Shreveport-Bossier business with affordable, advanced cybersecurity measures. Comprehensive protection against evolving cyber threats tailored for local businesses."
        />
      </Helmet>
      <div className={styles.contentContainer}>
        <img
          src={cybersecurityImage}
          alt="Cybersecurity Services for Shreveport-Bossier Businesses"
          className={styles.pageImage}
          loading="lazy"
        />
        <div className={styles.textContent}>
          <h3>Don't Be an Easy Target</h3>
          <p>
            Look, I'm not going to scare you with statistics about how many businesses get hacked. You've heard it all before. 
            Here's the truth: most cyberattacks succeed because of simple, fixable problems - weak passwords, no backups, 
            employees clicking phishing emails.
          </p>
          <p>
            I help local businesses fix the obvious security holes without spending a fortune. We're talking basic stuff that 
            prevents 90% of attacks: proper backups, security updates, training your team to spot sketchy emails, and making 
            sure you're not running on admin accounts all day.
          </p>
          <h3>What I Help With:</h3>
          <ul>
            <li>Security checkups to find obvious problems</li>
            <li>Setting up proper backups (the #1 defense against ransomware)</li>
            <li>Training your team to spot phishing emails</li>
            <li>Multi-factor authentication setup</li>
            <li>Security software that actually works</li>
          </ul>
          <p>
            No fear tactics, no upselling fancy tools you don't need. Just practical security that makes sense for 
            small businesses in Shreveport-Bossier.
          </p>
        </div>
      </div>
    </PageSection>
  );
}

export default CyberSecurity;
